import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './Login';
import Signup from './Signup'; // 🌟 회원가입 도화지 불러오기
import ReagentList from './ReagentList';
import TeacherDashboard from './TeacherDashboard';
import MyPage from './mypage'; // (이전 단계에서 소문자로 맞춘 이름 그대로!)

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} /> {/* 🌟 회원가입 경로 추가 */}
        <Route path="/student" element={<ReagentList />} />
        <Route path="/mypage" element={<MyPage />} />
        <Route path="/teacher" element={<TeacherDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;